import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetShift} from '../store/thunks/setGetShift';
import TableCasino from '../../../../@casino/ui/table';
import {useStyles, columns, getRow} from './helpers';
import Title from '../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../@casino/lib/getDate';

const CashiersShift = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetShift({
            page: 1,
            rowsPerPage: 10,
            search: '',
            date_from: 0,
            date_to: new Date().getTime()
        }));
    }, [])

    const shift = useSelector(state => state.cashiersShift.shift);
 
    const row = React.useMemo(() => getRow(shift), [shift]);

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});
    
    return (
        <div className={classes.root}>
            <Title label="Отчет по сменам" />
            <FormikContext.Provider value={formik}>
                <form style={{
                    padding: '0 20px',
                    background: '#1b2039', 
                    borderRadius: 8, 
                    marginBottom: 12,
                    width: 'calc(100% - 40px)',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetShift({
                                        search: formik.values.search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }
                                    formik.setFieldValue('date_to', date.getTime());
                                    dispatch(setGetShift({
                                        search: formik.values.search,
                                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                        date_to: isNaN(date.getTime()) ? new Date().getTime() : date.getTime(),
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))
                                    
                                }}
                            />
                        </div>
                    </div>
                    <input 
                        type="text"
                        placeholder="Поиск"
                        className={classes.search}
                        value={formik.values.search}
                        onChange={(v) => {
                            formik.setFieldValue('search', v.target.value)
                            dispatch(setGetShift({
                                search: v.target.value,
                                date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                page: 1,
                                rowsPerPage: 25,
                            }))
                        }}
                    />
                </form>
            </FormikContext.Provider>
            <div className={classes.wrapBlock}>
                <TableCasino 
                    width={1300}
                    columns={columns}
                    rows={row}
                />
            </div>
            
        </div>
    )
}

export default CashiersShift;